var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 2.99967H0.666992V12.333C0.666992 13.0663 1.26699 13.6663 2.00033 13.6663H11.3337V12.333H2.00033V2.99967ZM12.667 0.333008H4.66699C3.93366 0.333008 3.33366 0.933008 3.33366 1.66634V9.66634C3.33366 10.3997 3.93366 10.9997 4.66699 10.9997H12.667C13.4003 10.9997 14.0003 10.3997 14.0003 9.66634V1.66634C14.0003 0.933008 13.4003 0.333008 12.667 0.333008ZM12.667 9.66634H4.66699V1.66634H12.667V9.66634ZM8.00033 8.33301H9.33366V6.33301H11.3337V4.99967H9.33366V2.99967H8.00033V4.99967H6.00033V6.33301H8.00033V8.33301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.02353cabd861b957b677292aedbbc713.svg";
export { ForwardRef as ReactComponent };